import "./AddBoard.scss";
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const BOARD_ICONS = [
  "task_alt",
  "checklist",
  "dashboard",
  "view_kanban",
  "analytics",
  "campaign",
  "groups",
  "shopping_cart",
  "inventory_2",
  "rocket_launch",
  "emoji_objects",
  "psychology",
];

function AddBoard({ createBoard, cancelCreateBoard, existingBoard }) {
  const { t } = useTranslation();
  const [name, setName] = useState(existingBoard?.name || "");
  const [selectedIcon, setSelectedIcon] = useState(
    existingBoard?.icon || "task_alt",
  );

  const handleSubmit = () => {
    if (name.trim()) {
      createBoard(name.trim(), selectedIcon);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && name.trim()) {
      handleSubmit();
    }
  };

  return (
    <div className="add-board-modal">
      <h3>
        {existingBoard
          ? t("tasks.modals.addBoard.editTitle")
          : t("tasks.modals.addBoard.createTitle")}
      </h3>

      <div className="form-group">
        <label>{t("tasks.modals.addBoard.nameLabel")}</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={t("tasks.modals.addBoard.namePlaceholder")}
          autoFocus
          maxLength={50}
        />
      </div>

      <div className="form-group">
        <label>{t("tasks.modals.addBoard.icon")}</label>
        <div className="icon-selector">
          {BOARD_ICONS.map((icon) => (
            <div
              key={icon}
              className={`icon-option ${selectedIcon === icon ? "selected" : ""}`}
              onClick={() => setSelectedIcon(icon)}
            >
              <span className="material-symbols-outlined">{icon}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="button-group">
        <button className="cancel-button" onClick={cancelCreateBoard}>
          {t("common.cancel")}
        </button>
        <button
          className="create-button"
          onClick={handleSubmit}
          disabled={!name.trim()}
        >
          {existingBoard ? t("common.save") : t("common.create")}
        </button>
      </div>
    </div>
  );
}

AddBoard.propTypes = {
  createBoard: PropTypes.func.isRequired,
  cancelCreateBoard: PropTypes.func.isRequired,
  existingBoard: PropTypes.object,
};

AddBoard.defaultProps = {
  existingBoard: null,
};

export default AddBoard;
